/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import React, { useState, useEffect } from "react";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Colors from 'constants/Colors';
import { TagInput, Tags, Tag, TagTitle, InputTags, Container, PlaceHolder } from "./styles"
import Label from "components/Form/Label";

const TagsInput = (props) => {

    const [tags, setTags] = useState(props.tags);

    /* useEffect(() => {

        if (props.tags && props.tags.length > 0) {

            let files = props.tags;
            let arrfilenames = [];
            let file;

            for (let i = 0; i < files.length; i++) {
                file = files.item(i);
                arrfilenames.push(file.name);
            };

            setTags(arrfilenames)
            console.log("State fileNames: ", tags);

        } else {
            return;
        };

    }, [props.tags]) */

    const removeTags = index => {
        setTags([...tags.filter(tag => tags.indexOf(tag) !== index)]);
    };

    return (
        <Container>
            <InputTags>
                <Tags>
                    {tags ? tags.map((tag, index) => (
                        <Tag key={index} onClick={()=>{if(props.action){props.action(index)}}}>
                            <TagTitle>{tag}</TagTitle>
                            {props.readOnly ? <></> : 
                            <FontAwesomeIcon
                                icon={faTimes}
                                size='1x'
                                color={Colors.GRAY[6]}
                                style={{ display: "block", marginLeft: "8" }}
                                onClick={() => removeTags(index)}
                            />}
                        </Tag>
                    )) : ""}
                </Tags>
            </InputTags>
        </Container>
    );
};
export default TagsInput;